'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'comment';
var width = 512;
var height = 512;
var aliases = [128489,61669];
var unicode = 'f075';
var svgPathData = ['M16 240c0 51.7 18.8 99.4 50.5 137.4 4.1 4.9 4.9 11.7 2 17.4l-49.4 98.7 124.8-49.9c3.9-1.6 8.3-1.5 12.2 .1 30.4 13 64.2 20.2 99.9 20.2 133.5 0 240-101.2 240-224S389.5 16 256 16 16 117.2 16 240z', 'M66.5 377.4c4.1 4.9 4.9 11.7 2 17.4l-49.4 98.7 124.8-49.9c3.9-1.6 8.3-1.5 12.2 .1 30.4 13 64.2 20.2 99.9 20.2 133.5 0 240-101.2 240-224S389.5 16 256 16 16 117.2 16 240c0 51.7 18.8 99.4 50.5 137.4zM54.2 387.7C20.2 346.9 0 295.7 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240 397.4 480 256 480c-37.9 0-73.8-7.7-106.2-21.5L18.4 511C7.6 515.4-4 504 1.4 493.3L54.2 387.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComment = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;